/* =========================================================
   Desert City Games — DCG shared utilities
   File: assets/dcg-utils.js

   Single source of truth for cross-cutting cart logic. Loaded in <head>
   BEFORE every other dcg-*.js so window.DCG.parseLimit is defined by the
   time any cart script runs.

   Why this exists: purchase-limit parsing was previously reimplemented in
   four files (dcg-cart.js, dcg-cart-enforcer.js, dcg-qty-guard.js,
   dcg-product-card.js) with subtly different rules — e.g. "limit:5" and
   4-digit limits were honored in some entry paths but silently ignored in
   others. That meant the enforced limit depended on which path the customer
   used to add an item. This util unifies the rules.
========================================================= */
(function () {
  "use strict";

  window.DCG = window.DCG || {};

  var WORD_TO_NUM = {
    one: 1, two: 2, three: 3, four: 4, five: 5,
    six: 6, seven: 7, eight: 8, nine: 9, ten: 10
  };
  window.DCG.WORD_TO_NUM = WORD_TO_NUM;

  // Normalize input to an array of tag strings.
  // Accepts an array of tags OR a comma-separated string.
  function toTagArray(input) {
    if (Array.isArray(input)) return input;
    if (typeof input === "string") return input.split(",");
    return [];
  }

  /* parseLimit(tags) → Number | null
     Recognizes purchase-limit tags in ALL supported formats (superset of
     every previous implementation):
       limit-5   / limit:5     numeric, 1–4 digits
       limit-five              word form, one … ten
     Returns the LOWEST limit found across the tags, or null if none. */
  window.DCG.parseLimit = function (tags) {
    var arr = toTagArray(tags);
    if (!arr.length) return null;

    var limits = [];
    for (var i = 0; i < arr.length; i++) {
      var tag = String(arr[i] || "").trim().toLowerCase();
      if (!tag) continue;

      var m = tag.match(/^limit[-:](\d{1,4})$/);
      if (m) {
        var n = parseInt(m[1], 10);
        if (n > 0) limits.push(n);
        continue;
      }

      m = tag.match(/^limit-(one|two|three|four|five|six|seven|eight|nine|ten)$/);
      if (m) {
        var w = WORD_TO_NUM[m[1]];
        if (w) limits.push(w);
      }
    }

    return limits.length ? Math.min.apply(null, limits) : null;
  };
})();
